import { Pipe, PipeTransform } from '@angular/core';
/*
 * Converts newlines into html breaks
*/
@Pipe({ name: 'newline' })
export class NewlinePipe implements PipeTransform {
    transform(value: string, args: string[]): any {
        if (!value) {
            return '';
        }
        value = value.replace(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/g, (url) => {
            if (!url.startsWith('http')) {
                url = 'https://' + url;
            }
            return '<a href="' + url + '" target="blank_">' + url + '</a>';
        })
        return value.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/newline.pipe.ts